const convertMillisecondsToOnlyDate = (seconds) => {
    const date = new Date(seconds * 1000);
  
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    };
  
    return date.toLocaleDateString('en-US', options); 
  };
  
  export default convertMillisecondsToOnlyDate;
  